// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ihIzW","topLabel":"styles_topLabel__HNG67","topLabelVal":"styles_topLabelVal__eKcer"};